import { Check } from "lucide-react";

interface FeatureSection {
  headline: string;
  bullets: string[];
  imageUrl?: string;
}

interface FeatureSectionsProps {
  sections: FeatureSection[];
}

export const FeatureSections = ({ sections }: FeatureSectionsProps) => {
  if (!sections || sections.length === 0) return null;

  return (
    <div className="space-y-16">
      {sections.map((section, index) => {
        const isImageLeft = index % 2 === 0;
        
        return (
          <div
            key={index}
            className={`flex flex-col ${isImageLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 lg:gap-12 items-center`}
          >
            {/* Image */}
            {section.imageUrl && (
              <div className="w-full lg:w-1/2">
                <img
                  src={section.imageUrl}
                  alt={section.headline}
                  className="w-full h-auto rounded-xl shadow-lg object-cover"
                />
              </div>
            )}
            
            {/* Content */}
            <div className={`w-full ${section.imageUrl ? 'lg:w-1/2' : 'lg:w-full'}`}>
              <h3 className="text-2xl lg:text-3xl font-bold mb-6 text-foreground">
                {section.headline}
              </h3>
              <ul className="space-y-4">
                {section.bullets.filter(b => b).map((bullet, bulletIndex) => (
                  <li key={bulletIndex} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center mt-0.5">
                      <Check className="w-4 h-4 text-primary" />
                    </div>
                    <span className="text-muted-foreground text-base lg:text-lg leading-relaxed">
                      {bullet}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};
